import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="about-container">
        <div className="about-greeting">
          <h3 className="script-greeting">Hello There,</h3>
        </div>
        
        <div className="about-intro">
          <h2 className="about-name">I am <span className="pink-text">Kristijana</span></h2>
        </div>

        <div className="about-description">
          <p className="about-text">
            A computer science student who enjoys both aesthetics
            and programming. 
            I like building clean, simple and
            user-friendly web applications.
          </p>
        </div>

        <div className="about-details">
          <div className="detail-item">
            <span className="detail-number pink-text">3+</span>
            <span className="detail-label">YEARS IN TECH INDUSTRY</span>
          </div>
          <div className="detail-item">
            <span className="detail-number pink-text">10+</span>
            <span className="detail-label">PERSONAL PROJECTS</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;